import React, { FC } from "react";
import { Control, useController } from "react-hook-form";

import SwitchBase, { SwitchProps } from "@/components/ui/Form/Switch/SwitchBase";

export interface SwitchControlledProps extends SwitchProps {
  control: Control;
}
const SwitchControlled: FC<SwitchControlledProps> = ({ control, ...rest }) => {
  const { name } = rest;
  const { field, fieldState } = useController({ control, name });
  return <SwitchBase field={field} fieldState={fieldState} {...rest} />;
};
export default SwitchControlled;
